/**
 * 提供所有可用的控件，以及后续注册新的控件
 */
class FormItemFactory {
  constructor() {
    this.registeredControls = {};
  }
  /**
   * 注册单个控件
   * @param {Object} control 控件定义
   */


  register(control) {
    if (Array.isArray(control)) {
      control.forEach(c => this.register(c));
      return;
    }

    const {
      meta
    } = control;

    if (!meta || !meta.name) {
      console.warn('[FormItemFactory] register failed, invalid control', control);
      return;
    }

    this.registeredControls[meta.name] = control;
  }
  /**
   * 根据控件名称获取控件定义
   * @param {String} name 控件名称
   */


  getControl(name) {
    return this.registeredControls[name] || null;
  }
  /**
   * 判断控件是否已注册
   * @param {String}} name 控件名称
   */


  supportType(name) {
    return name in this.registeredControls;
  }

}

export default FormItemFactory;